<template>
    <div class="invoice">
        <el-container>
            <el-main ref="main">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
                        <div class="container">
                            <div class="titleBox">
                                <div>申请信息：</div>
                                <div class="titleNum">编号：{{dataForm.approveCode}}</div>
                            </div>
                            <el-form class="dataFormBox" :inline="true" :model="dataForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="项目部：">
                                            <el-input v-model="dataForm.projectDeptName" :readonly="true" placeholder="请输入项目名称" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="项目名称：">
                                            <el-input v-model="dataForm.projectName" :readonly="true" placeholder="请输入项目名称" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="欠款单位：">
                                            <el-input v-model="dataForm.debtName" :readonly="true" placeholder="请输入欠款单位" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="项目地点：">
                                            <el-input v-model="dataForm.projectAddress" :readonly="true" placeholder="请输入项目地点" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="发票抬头：">
                                            <el-input v-model="dataForm.billHead" :readonly="true" placeholder="请输入发票抬头" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="纳税人识别号：">
                                            <el-input v-model="dataForm.billTaxNumber" :readonly="true" placeholder="请输入纳税人识别号" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="地址：">
                                            <el-input v-model="dataForm.address" :readonly="true" placeholder="请输入地址" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="电话：">
                                            <el-input v-model="dataForm.phone" :readonly="true" placeholder="请输入电话" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="开户行：">
                                            <el-input v-model="dataForm.bank" :readonly="true" placeholder="请输入开户行" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="账号：">
                                            <el-input v-model="dataForm.bankAccount" :readonly="true" placeholder="请输入账号" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                  <el-col :span="12">
                                    <el-form-item label-width="120px" label="发票类型：">
                                      <el-input v-model="dataForm.categoryDisplayName" :readonly="true" placeholder="请选择发票类型" clearable></el-input>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="12">
                                    <el-form-item label-width="120px" label="发票种类：">
                                      <el-input v-model="dataForm.typeDisplayName" :readonly="true" placeholder="请选择发票种类" clearable></el-input>
                                    </el-form-item>
                                  </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="不含税金额：">
                                            <el-input v-model="dataForm.notTaxPrice" :readonly="true" placeholder="请输入不含税金额" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="税额：">
                                            <el-input v-model="dataForm.taxPrice" :readonly="true" placeholder="请输入税额" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="税率：">
                                            <el-input v-model="dataForm.taxRatio" :readonly="true" placeholder="请输入税率" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="发票金额：">
                                            <el-input v-model="dataForm.price" :readonly="true" placeholder="请输入发票金额" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item style="width: 100%" label-width="120px" label="发票备注：">
                                            <el-input v-model="dataForm.remark" show-word-limit
                                                      type="textarea" :rows="2" maxlength="200" :readonly="true"
                                                      placeholder="请输入发票备注" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="申请人：">
                                            <el-input v-model="dataForm.approveUserName" :readonly="true" placeholder="请输入申请人" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="申请日期：">
                                            <el-input v-model="dataForm.approveTime" :readonly="true" placeholder="请输入申请日期" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="titleBox">
                                <div>录入发票信息：</div>
                            </div>
                        </div>
                        <div class="containerBox">
                            <el-form class="dataFormBox" :inline="true" :model="userForm">
                                <el-row v-for="(billItem,billIndex) in billList" :key="'billItem'+ billIndex"
                                        class="billList">
                                    <el-col :span="1">
                                        <div class="deleteIcon" @click="deleteBillItem(billIndex)">
                                            <i class="el-icon-remove" ></i>
                                        </div>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label-width="100px" label="发票号码：">
                                            <el-input v-model="billItem.billNumber" placeholder="请输入发票号码" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label-width="120px" label="发票金额：">
                                            <el-input v-model="billItem.billPrice" placeholder="请输入发票金额" clearable
                                                      @input="limitInput($event, billItem,'billPrice')"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item class="uploadBox" label-width="120px" label="发票附件：">
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="actionUrl"
                                                    :headers="importHeaders"
                                                    :data="uploadData"
                                                    :limit = '1'
                                                    :on-success="(res, file, fileList) => { return handleSuccess(res, file, fileList, billItem) }"
                                                    :on-remove="(file, fileList) => {return handleRemove(file, fileList, billItem)}"
                                                    :file-list="billItem.fileList"
                                                    list-type="picture">
                                                <el-button size="small" type="primary">点击上传</el-button>
                                            </el-upload>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div class="addBtn" @click="addBillItem">
                                    <i class="el-icon-plus"></i>
                                </div>
                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="审批流程" name="Tab2" >
                      <approveLine
                          :itemId="contractId"
                          :approveType="approveType"
                      ></approveLine>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="container">
                <div class="btnMid">
                    <el-button type="primary" @click="submit()">提 交</el-button>
                    <el-button type="info" @click="reset()">取 消</el-button>
                </div>
            </el-footer>
        </el-container>

    </div>
</template>

<script>
    import config from "@/common/config";
    import  {
        getApproveDetailService,
        getInvoiceApproveListService,
        invoiceBatchService,
        getTempUrlService,
    } from '@/services/invoiceServices'
    import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //审批流程
    export default {
        name: "sales-input",
        data(){
            return {
                dataForm:{
                    approveCode:'',
                    projectDeptName:'',
                    projectName:'',
                    debtName: '',
                    projectAddress: '',
                    billHead: '',
                    billTaxNumber: '',
                    address: '',
                    phone: '',
                    bank: '',
                    bankAccount: '',
                    notTaxPrice: '',
                    taxPrice: '',
                    taxRatio: '',
                    price: '',
                    remark: '',
                    approveUserName:'',
                    approveTime:'',
                },
                userForm:{
                    licenseNumber:'',
                },
                activeName: 'Tab1',
                editableTabs: [{
                    label: '基本信息',
                    name: 'Tab1'
                },{
                    label: '审批流程',
                    name: 'Tab2'
                }],

                contractId: 0, // 审批流列表
                approveType: "OUTPUT_BILL_APPROVE", //审批类型

                approveId:'', //申请id
                actionUrl: '', //上传图片url
                uploadData: {
                    category:'OUTPUT',
                },
                importHeaders:{
                    Authorization: sessionStorage.getItem('accessToken')
                },
                billList: [{
                    approveId:'',
                    billNumber:'',
                    billPrice:'',
                    billAttachmentUrl:'',
                    fileList:[],
                }], //发票信息
            }
        },
        components:{
            approveLine
        },
        methods:{
            onActive(menuCode) {
                this.approveId = this.tabRouteParam.approveId;
                this.contractId = this.tabRouteParam.approveId;
                this.billList[0].approveId = this.approveId;
                this.actionUrl = config.baseUrl+'/finance-web/oss/upload/finance/singleItem';
                this.getApproveDetail();
                // this.getApproveList(); // 获取该审批流程
            },
            /**
             * 获取申请发票详情
             * */
            getApproveDetail(){
                let paramsData = {
                    approveId: this.approveId
                }
                getApproveDetailService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.dataForm = res.data;
                        if(res.data.billItemVOList){
                            this.billList = [];
                            res.data.billItemVOList.map((item,index) => {
                                this.billList.push({
                                    approveId: item.approveId,
                                    billNumber: item.billNumber,
                                    billPrice: item.billPrice,
                                    billAttachmentUrl: item.billAttachmentUrl,
                                    fileList:[],
                                })
                                this.getTempUrl(item.billAttachmentUrl, index);
                            })
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /***
             * 获取图片路径
             */
            getTempUrl(url,index){
                let params = {
                    filePath: url
                }
                getTempUrlService(params).then( res => {
                    if(res.code == 10000000){
                        this.billList[index].fileList.push({name: '', url: res.data});
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });

            },
            submit(){
                for (let i = 0; i< this.billList.length; i++){
                    console.log(i)
                    if(!this.billList[i].billAttachmentUrl ||!this.billList[i].billNumber ||!this.billList[i].billPrice ){
                        this.$message.error('请完善录入发票信息');
                        return
                    }
                }
                let paramsData = {
                    outputBillList:this.billList
                }
                invoiceBatchService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.$message.success("提交成功");
                        this.reset();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                this.bus.$emit("tabClose", "salesInput");
                this.bus.$emit("navMenuChange", {
                    routeId: "salesInvoice"
                });
            },

            /***
             * 获取该审批流程
             */
            getApproveList(){
                let params = {
                    itemId: this.approveId,
                    approveClass: 'OUTPUT_BILL_APPROVE',
                }
                getInvoiceApproveListService(params).then( res => {
                    if(res.code == 10000000){
                        this.approveList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // tabbar切换
            handletabClick(tab, event){
                console.log(tab)
            },
            selectApproveTarget(item) {
                // 选择对应的审批人
                this.approveDialogOptions = {
                    approveVO: item,
                };
                this.approveDialogVisible = true;
            },
            approveDialogClose(data) {
                console.log("审批流程,关闭", data);
                this.approveDialogVisible = false;
                if (data) {
                    // 选了人了
                    this.approveList.forEach((item) => {
                        if (item.jobId == data.jobId) {
                            item.approveUserId = data.id;
                            item.approveUserName = data.displayName || data.name;
                            item.deptId = data.deptId;
                            item.deptName = data.deptDisplayName;
                            // item.jobId = data.jobId;
                            // item.jobName = data.jobName;
                        }
                    });
                }
            },
            // 新增发票信息
            addBillItem(){
                this.billList.push({
                    approveId:this.approveId,
                    billNumber:'',
                    billPrice:'',
                    billAttachmentUrl:'',
                    fileList:[],
                })
            },
            // 删除发票信息
            deleteBillItem(index){
                console.log(index)
                if(this.billList.length == 1){
                    this.$message.error('至少填写一份发票信息');
                }else{
                    this.billList.splice(index,1);
                }
            },

            handleRemove(file, fileList, billItem) {
                billItem.billAttachmentUrl = '';
            },
            handleSuccess(res, file, fileList, billItem) {
                billItem.billAttachmentUrl = res.data.resource;
            },
            limitInput(value, billItem, name) {
                let val = (value && value.split("")) || [];
                let reg1 = /\d/;
                let reg2 = /\./;
                // 第一个字符不能为小数点
                if (val[0] == ".") {
                    billItem[name] = "";
                    return;
                }
                // 过滤掉除数字和小数点外的字符
                val = val.filter((e) => reg1.test(e) || reg2.test(e));
                // 匹配小数点后只能有两位小数
                // 解释一下这个match正则规格
                // ^\d* 是指以数字开头，后面允许输入0到多位数字
                // (\.?) 是指只允许一个小数点
                // \d{0,2} 是指只允许0到2位小数
                billItem[name] = val.join("").match(/^\d*(\.?\d{0,2})/g)[0] || null;
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
        }
        .containerBox{
            width: 1200px;
        }
      /deep/.el-table__body-wrapper{
        height: 500px !important;
      }
    }
    /deep/.el-textarea{
        width: 600px;
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .uploadBox {
        display: flex;
        align-items: center;
    }
    /deep/.upload-demo{
        display: flex;
        align-items: center;
        .el-icon-close:before{
            color: #000000;
        }
        .el-upload-list__item{
            margin-top: 0px;
            margin-left: 10px;
        }
        .el-upload-list__item-name{
            margin-right: 0px;
            width: 75px;
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .dataFormBox{
        margin:30px 20px;
    }
    .btnMid {
        width: 300px;
        margin: 15px auto 0;
        display: flex;
        justify-content: space-around;
    }
    .addBtn {
        width: 25px;
        height: 25px;
        background: #000;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 50px;
        border-radius: 4px;
        i {
            font-size: 18px;
            color: #fff;
            font-weight: 600;
        }
    }
    .billList{
        display: flex;
        align-items: center;
        .deleteIcon{
            height: 56px;
            i {
                font-size: 20px;
                padding-top: 9px
            }
        }
    }
    /deep/.el-tabs__item{
        padding: 0 20px !important;
    }
</style>
